module.exports = __webpack_public_path__ + "img/asset10.5729da6d.png";